// PASTE #251 PR-4 (L5 / AUTH_AUDIT): shared classification of Cognito
// sign-in errors, so the password path and the magic-link path surface
// the same "account inactive" copy for a disabled account. Pure (no
// Amplify import) so it is unit-testable.

// True when a Cognito error is the disabled-account case. Cognito raises
// NotAuthorizedException with message "User is disabled." on a disabled
// user; the password path already keys the accountInactive copy on this.
export function isDisabledAccountError(err: unknown): boolean {
  return err instanceof Error && /User is disabled/i.test(err.message);
}

// Magic-link sign-in uses CUSTOM_WITHOUT_SRP - there is no password to be
// wrong - so a bare NotAuthorizedException on that flow means the account
// is disabled. Broadened accordingly (still covers the explicit "User is
// disabled" message from any SDK version).
export function isMagicLinkDisabledError(err: unknown): boolean {
  if (isDisabledAccountError(err)) return true;
  return err instanceof Error && err.name === "NotAuthorizedException";
}
